import { prefixRelativeUrl, isFeatureActive } from '../util.js';

$(function () {
    const level = ($link) => $link.parents('[role="group"]').length;
    const bg = (lvl) => ['bg-primary-light', 'bg-tertiary-light', 'bg-light'][lvl % 3];

    const linkMenuItem = (item, lvl) =>
        `<li role="none">
       <a role="treeitem"
          tabindex="-1"
          data-item-contentid="${item.ContentId}"
          class="d-block py-2 menu-level-${lvl} text-dark" 
          href="${prefixRelativeUrl(item.Url)}">${item.Title}</a>
    </li>`;

    const toggleMenuItem = (item, lvl) =>
        `<li role="treeitem"
       id="responsive-treeitem-${item.ContentId}"
       class="d-block toggle-sub-menu"
       data-item-contentid="${item.ContentId}"
       tabindex="-1"
       aria-expanded="false">
       <div class="d-flex flex-row justify-content-between">
           <a href="${item.Url}" class="menu-level-${lvl} py-2 d-block w-100 text-dark">${
               item.Title
           }</a>
           <button 
              class="sub-menu-toggle-button px-2 border-0 border-left border-medium border-white"
              aria-label="Undermeny för ${item.Title}"
              data-treeitem="responsive-treeitem-${item.ContentId}">
            <svg viewBox="0 0 24 24" class="caret" aria-hidden="true">
               <use href="${prefixRelativeUrl('/dist/spritemap.svg#sprite-caret-right')}"></use>
             </svg>
           </button>
       </div>
       <div class="sub-menu-mount"
            data-item-contentid="${item.ContentId}"
            data-item-href="${prefixRelativeUrl(item.Url)}"
            data-item-title="${item.Title}"></div>
     </li>`;

    const fetchMenuItems = (contentId) =>
        $.getJSON(prefixRelativeUrl(`/__navigation/menuitems/${contentId}`));

    const toggleAriaExpanded = ($element) =>
        $element.attr(
            'aria-expanded',
            $element.attr('aria-expanded') === 'false' ? 'true' : 'false'
        );

    $('#toggle-main-menu').on('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        $('#main-menu-container').toggleClass('d-none');
        toggleAriaExpanded($(event.currentTarget));

        trapFocus();
        toggleBackDrop();
        toggleDisableHeaderItems();

        // Scroll menu to active menuitem, if it exists
        const foundActiveItem = $('li[role="treeitem"] a.active').first();

        if (foundActiveItem.length === 1) {
            const menuContainer = $('.main-menu-container');
            menuContainer.scrollTop(
                menuContainer.scrollTop() -
                    menuContainer.offset().top +
                    foundActiveItem.offset().top
            );
        }
    });
    //disable search and shoppingcarticon when responsive menu open
    const toggleDisableHeaderItems = () => {
        document.querySelectorAll('#site-menu > *').forEach(function (element) {
            if (element.id == 'toggle-search-field' || element.id == 'shopping-cart-top-link') {
                if (document.body.classList.contains('menu-open')) {
                    element.classList.add('isdisabled');
                } else {
                    element.classList.remove('isdisabled');
                }
            }
        });
    };
    //add backgrop when responsive menu open
    const toggleBackDrop = () => {
        const body = document.body;
        if (!body.classList.contains('menu-open')) {
            body.classList.add('backdrop', 'menu-open');
        } else {
            body.classList.remove('backdrop', 'menu-open');
        }
    };
    //keep tab withing menu responsive menu open
    const trapFocus = () => {
        var element = document.getElementById('site-menu');
        var focusableEls = element.querySelectorAll(
            'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
        );
        var firstFocusableEl = document.getElementById('toggle-main-menu');
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var KEYCODE_TAB = 9;

        element.addEventListener('keydown', function (e) {
            var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                /* shift + tab */ if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } /* tab */ else {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    };

    const toggleGroup = ($treeitem) => {
        $treeitem.children('[role="group"]').toggleClass('d-none');
        toggleAriaExpanded($treeitem);
        return;
    };

    const populateGroup = ($mount, lvl) => {
        const contentId = $mount.data('item-contentid');
        //const first = linkMenuItem({
        //  Url: $mount.data('item-href'),
        //  Title: `Gå till ${$mount.data('item-title')}`,
        //  ContentId: 'u' + $mount.data('item-contentid')
        //}, lvl);

        fetchMenuItems(contentId).done((data) => {
            const itemsHtml = [
                ...data.map((item) =>
                    item.HasChildren ? toggleMenuItem(item, lvl) : linkMenuItem(item, lvl)
                )
            ].join('');
            $mount.parent('.toggle-sub-menu').attr('aria-expanded', 'true');
            $mount.replaceWith(
                `<ul role="group" class="list-unstyled ${bg(lvl)}">${itemsHtml}</ul>`
            );
        });
    };

    const focusItem = (activeItem) => {
        $('#main-menu-container [tabindex="0"]').attr('tabindex', '-1');
        $(activeItem).attr('tabindex', '0').focus();
    };

    const handleGroupToggle = ($treeitem) => {
        if ($treeitem.has('[role="group"]').length) {
            toggleGroup($treeitem);
            return;
        }

        const $mount = $treeitem.children('.sub-menu-mount');
        if ($mount.length) {
            var lvl = level($treeitem);
            populateGroup($mount, lvl);
        }
    };

    const visibleFocusables = () =>
        $('#main-menu-container').find('[role="treeitem"][tabindex]:visible');

    const moveFocus = ($current, direction) => {
        const currentId = $current.data('item-contentid');
        const $visible = visibleFocusables();
        const currentIndex = $visible
            .get()
            .findIndex((element) => $(element).data('item-contentid') === currentId);
        const nextIndex = currentIndex + (direction === 'down' ? 1 : -1);

        if (0 <= nextIndex && nextIndex < $visible.length) {
            focusItem($visible[nextIndex]);
        }
    };

    $('#main-menu-container').on('click keydown', '.sub-menu-toggle-button', (event) => {
        // Check if the event is a keypress and if the key is Enter (13) or Space (32)
        if (event.type === 'keydown' && event.which !== 13 && event.which !== 32) {
            return; // if it's a keypress but not Enter or Space, do nothing
        }

        // Prevent the default action for Space key to stop it from scrolling the page
        if (event.which === 32) {
            event.preventDefault();
        }
        handleGroupToggle($(`#${$(event.currentTarget).data('treeitem')}`));
    });

    // keyboard interface, mainly inspired by:
    // https://www.w3.org/TR/wai-aria-practices-1.1/examples/treeview/treeview-2/treeview-2a.html
    $('#main-menu-container').on('keydown', '[role="treeitem"]', (event) => {
        if (event.key === 'Tab') return;

        event.preventDefault();
        event.stopPropagation();

        const $target = $(event.target);
        switch (event.key) {
            case 'Enter':
            case ' ' /*Space*/:
                if ($target.is('a')) window.location.href = $target.attr('href');
                if ($target.is('li')) handleGroupToggle($target);
                break;

            case 'ArrowDown':
                moveFocus($target, 'down');
                break;

            case 'ArrowUp':
                moveFocus($target, 'up');
                break;

            case 'ArrowRight':
                if ($target.is('[aria-expanded="true"]')) {
                    focusItem($target.find('[tabindex]').first());
                }
                if ($target.is('[aria-expanded="false"]')) {
                    handleGroupToggle($target);
                }
                break;

            case 'ArrowLeft':
                if ($target.is('[aria-expanded="true"]')) {
                    handleGroupToggle($target);
                } else {
                    focusItem($target.parents('[tabindex]').first());
                }
                break;

            case 'Home':
                focusItem(visibleFocusables().first());
                break;

            case 'End':
                focusItem(visibleFocusables().last());
                break;

            case '*':
                // expands all closed groups on same level as target
                $target
                    .closest('[role="group"], [role="tree"]')
                    .children('[aria-expanded="false"]')
                    .each((_, item) => handleGroupToggle($(item)));
                break;

            case 'Escape':
                $('#main-menu-container').toggleClass('d-none');
                $('#toggle-main-menu').focus();
                break;

            default:
                const letter = event.key.match(/^[a-zåäö]$/i);
                if (letter) {
                    const $candidates = visibleFocusables().map((i, element) => {
                        const $element = $(element);
                        return {
                            index: i,
                            id: $element.data('item-contentid'),
                            element: $element
                        };
                    });

                    const $matches = $candidates.filter((_, item) => {
                        return item.element.get(0).innerText.startsWith(letter[0].toUpperCase());
                    });

                    if (!$matches.length) break;

                    const currentId = $target.data('item-contentid');
                    const currentIndex = $candidates
                        .filter((i, x) => x.element.data('item-contentid') == currentId)
                        .first()
                        .get(0).index;

                    const next = $matches.get().filter((item) => item.index > currentIndex);

                    if (next.length) {
                        focusItem(next[0].element);
                    } else {
                        focusItem($matches[0].element);
                    }
                }
                break;
        }
    });

    // Sticky menu on scroll up, hide on scroll down
    const $body = $('body');
    let lastScroll = 0;
    const scrollDown = 'scrollDown';
    const scrollUp = 'scrollUp';
    $(window).on('scroll', () => {
        const currentScroll = window.pageYOffset;
        const isMenuExpanded = $('#toggle-main-menu').attr('aria-expanded') === 'true';

        if (
            currentScroll > 0 &&
            currentScroll > lastScroll &&
            !$body.hasClass(scrollDown) &&
            !isMenuExpanded
        ) {
            $body.addClass(scrollDown);
            $body.removeClass(scrollUp);
        } else if (currentScroll < lastScroll && $body.hasClass(scrollDown)) {
            $body.addClass(scrollUp);
            $body.removeClass(scrollDown);
        } else if (currentScroll === 0) {
            $body.removeClass(scrollUp);
            $body.removeClass(scrollDown);
        }

        lastScroll = currentScroll;
    });
});

$(function () {
    $('#toggle-search-field').click((event) => {
        if ($(event.currentTarget).is('[aria-expanded="false"]')) {
            $('.search-wrapper').show();
            $('.search-wrapper #search-input').focus();
            $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
            $('.search-wrapper').hide();
            $(event.currentTarget).attr('aria-expanded', 'false');
        }
    });
});
